import { useState } from "react";
import { Input } from "../Input/Input";
import type { InputProps } from "../Input/Input";
import { CopyToClipboard as Copy } from "react-copy-to-clipboard";
import { Button } from "../Button/Button";
import type { Maybe } from "../types";

import * as styles from "./CopyToClipboard.module.scss";

type CopyToClipboardProps = {
  toCopy: Maybe<string>;
  loading?: boolean;
  onCopied?: () => void;
  inputLoading?: boolean;
} & InputProps;

const CopyToClipboard = (props: CopyToClipboardProps) => {
  const [isCopied, setCopied] = useState(false);
  return (
    <Input
      loading={!!props.inputLoading}
      data-testid="copyable-input"
      inputClassName={styles.input}
      icon={
        <Copy text={props.toCopy || ""}>
          <Button
            size="sm"
            className={styles.icon}
            loading={!!props.loading}
            disabled={!!props.loading}
            onClick={() => {
              setCopied(true);
              setTimeout(() => setCopied(false), 3000);

              props.onCopied?.();
            }}
          >
            {isCopied ? "Copied!" : "Copy"}
          </Button>
        </Copy>
      }
      {...props}
    />
  );
};
CopyToClipboard.displayName = "CopyToClipboard";

export { CopyToClipboard };
